import React from 'react';
import LazyAsset from 'components/LazyAsset';
import { NARRATIV_ACCOUNT_NAME } from 'constants/vendor';

const URL = `https://static.narrativ.com/tags/${NARRATIV_ACCOUNT_NAME}.js`;

function Narrativ() {
  return <LazyAsset type="js" uri={URL} parentTag="head" />;
}

export default Narrativ;
